import { t } from "i18next";

const LanguageSelection = ({ primary, botLanguages, languages, handleLanguageSelection }) => {
    return (
        <div className="flex items-center justify-center h-full bg-[#f5f5f5]">
            <div className="flex flex-col items-center justify-center">
                <h1 className="text-lg font-bold text-center mb-8">{t('Choose the language you want to chat')}</h1>
                <div className="flex items-center justify-center gap-4 flex-wrap">
                    {languages
                        .filter((lng) => botLanguages.includes(lng.value))
                        .map((lng) => (
                            <button
                                className="w-32 h-32 flex items-center justify-center flex-col text-lg gap-1 cursor-pointer border-0 rounded-lg transition-all duration-300 lngBtn"
                                key={lng?.id}
                                value={lng.value}
                                onClick={() => handleLanguageSelection(lng)}
                                // style={{
                                //     '--hover-bg': primary,
                                // }}
                                onMouseEnter={e => {
                                    e.currentTarget.style.backgroundColor = primary;
                                    e.currentTarget.style.color = 'white';
                                }}
                                onMouseLeave={e => {
                                    e.currentTarget.style.backgroundColor = 'white';
                                    e.currentTarget.style.color = 'black';
                                }}
                            >
                                <span className="capitalize text-inherit">{lng?.id}</span>
                                <span className="text-inherit">{lng?.name}</span>
                            </button>
                        ))}
                </div>
            </div>
        </div>
    )
}

export default LanguageSelection;